import {Card, Typography} from 'antd';
import {Link as RouterLink} from "react-router-dom";

const {Link, Text} = Typography;

export default function HomeView() {
    return (
        <Card title="Witamy w module zajęć do wyboru systemu intraMuz!">
            <p>Moduł pozwala dokonać wyboru zajęć, które stanowić będą 30% programu kształcenia, czyli około 9 punktów
                ECTS na semestr.</p>
            <p>Uwaga! Informację o minimalnej liczbie punktów ECTS, którą należy uzyskać za zaliczenie przedmiotów w
                poszczególnych grupach należy sprawdzić w planach studiów:</p>
            <p>
                Wydział I:
                <Link
                    href="https://www.amuz.gda.pl/wydzialy/wydzial-i-dyrygentury-kompozycji-i-teorii-muzyki/plany-studiow,145"
                    target="_blank">
                    https://www.amuz.gda.pl/wydzialy/wydzial-i-dyrygentury-kompozycji-i-teorii-muzyki/plany-studiow,145</Link>
            </p>
            <p>
                Wydział II:
                <Link
                    href="https://www.amuz.gda.pl/wydzialy/wydzial-ii-instrumentalny/plany-studiow,150" target="_blank">
                    https://www.amuz.gda.pl/wydzialy/wydzial-ii-instrumentalny/plany-studiow,150</Link>
            </p>
            <p>
                Wydział III:
                <Link
                    href="https://www.amuz.gda.pl/wydzialy/wydzial-iii-wokalno-aktorski/plany-studiow,155"
                    target="_blank">
                    https://www.amuz.gda.pl/wydzialy/wydzial-iii-wokalno-aktorski/plany-studiow,155</Link>
            </p>
            <p>
                Wydział IV:
                <Link
                    href="https://www.amuz.gda.pl/wydzialy/wydzial-iv-dyrygentury-choralnej-muzyki-koscielnej-edukacji-artystycznej-rytmiki-i-jazzu/plany-studiow,160"
                    target="_blank">
                    https://www.amuz.gda.pl/wydzialy/wydzial-iv-dyrygentury-choralnej-muzyki-koscielnej-edukacji-artystycznej-rytmiki-i-jazzu/plany-studiow,160</Link>

                <br/>
            </p>
            <p>
                Wybory zapisują się automatycznie. Wybór można zmieniać i zapisywać wielokrotnie, jednak nie później niż do 2 października 2026 r. Każda zmiana aktualizuje datę zapisu wyłącznie dla modyfikowanego wyboru.
            </p>
            <p>
                Wszelkie pytania techniczne należy kierować na adres: <a
                href="mailto:przedmiotydowyboru@amuz.gda.pl">przedmiotydowyboru@amuz.gda.pl</a>
            </p>
            <p>
                Pytanie merytoryczne należy kierować do właściwych prodziekanów.
            </p>
            <p>
                Aby przejść do wyboru zajęć należy kliknąć: <RouterLink to="/elective"><Text
                italic>Przedmioty</Text></RouterLink>
            </p>
            <p>
                Uwaga: W obecnej wersji aplikacji Twoje wybory są zapisywane automatycznie za każdym razem, gdy zaznaczysz lub odznaczysz przedmiot. Niepotrzebny przycisk zapisywania został usunięty.
            </p>
        </Card>
    )
}